import React from "react";
import NewsLetterArea from "./NewsLetterArea";

function Subscribe(props) {
  const { ctype } = props.match.params;
  const { item_id } = props.match.params;

  return (
    <>
      <NewsLetterArea ctype={ctype} item_id={item_id} />
    </>
  );
}

export default Subscribe;
